module.exports = __webpack_public_path__ + "img/wx.e7862c6d.png";